module.exports = __webpack_public_path__ + "img/43.7eb829b7.svg";